import { create } from 'zustand'
import type { AuthContextType, OrgTier, Organization, Permission, Session, User, UserRole } from '@/contexts/auth/types'
import { rolePermissions } from '@/contexts/auth/types'

export type { AuthContextType, OrgTier, Organization, Permission, Session, User, UserRole }
export { rolePermissions }

type AuthState = AuthContextType

const noop = async () => {}

export const useAuthStore = create<AuthState>()(() => ({
  isLoaded: false,
  isSignedIn: false,
  user: null,
  organization: null,
  session: null,
  signIn: noop as AuthState['signIn'],
  signInWithGoogle: noop,
  signInWithGithub: noop,
  signInWithMagicLink: noop as AuthState['signInWithMagicLink'],
  signUp: noop as AuthState['signUp'],
  signOut: noop,
  updateUserName: noop as AuthState['updateUserName'],
  updateUserAvatar: noop as AuthState['updateUserAvatar'],
  setUserRole: () => {},
  setOrgTier: () => {},
  requestDowngrade: noop as AuthState['requestDowngrade'],
  cancelDowngrade: noop,
  hasPermission: () => false,
  hasRole: () => false,
  simulateExpiredSession: () => {},
}))

// Convenience hook matching the old useAuth() API exactly.
export function useAuth(): AuthState {
  return useAuthStore()
}
